<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="600px">
        <div class="row" v-loading="loading">
            <div class="col-12">
                <x-select v-model="form.virtual_shop_id"
                          :options="virtual_shops"
                          label="Tienda virtual"></x-select>
            </div>
            <div class="col-6">
                <x-select v-model="form.shipping_agency_id"
                          :options="shipping_agencies"
                          label="Agencia de envío"></x-select>
            </div>
            <div class="col-6">
                <x-select v-model="form.shipping_type_id"
                          :options="shipping_types"
                          label="Tipo de envío"></x-select>
            </div>
            <div class="col-12" v-if="form.shipping_type_id === '03'">
                <x-input v-model="form.payment_method_type"
                         label="Método de pago"></x-input>
            </div>
            <template v-if="form.shipping_type_id === '02'">
                <div class="col-12">
                    <x-input v-model="form.destination_agency"
                             label="Agencia de destino"></x-input>
                </div>
            </template>
            <template v-else>
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="control-label">Ubigeo</label>
                        <el-cascader v-model="form.location_id"
                                     :options="locations"
                                     filterable></el-cascader>
                    </div>
                </div>
                <div class="col-12">
                    <x-input v-model="form.address"
                             label="Dirección"></x-input>
                </div>
                <div class="col-12">
                    <x-input v-model="form.address_reference"
                             label="Referencia"></x-input>
                </div>
                <div class="col-12">
                    <x-input v-model="form.google_maps"
                             label="Google maps"></x-input>
                </div>
            </template>
            <div class="col-6">
                <x-input v-model="form.cellphone_number"
                         label="Número de celular"></x-input>
            </div>
            <div class="col-6">
                <x-input v-model="form.number_of_packages"
                         label="Cantidad de paquetes"></x-input>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="onSubmit"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../components/Form/XButtonSubmit";
import XModal from "../../../components/XModal";
import XInput from "../../../components/Form/XInput.vue";
import XButtonIcon from "../../../components/Form/XButtonIcon.vue";
import XSelect from "../../../components/Form/XSelect.vue";

export default {
    name: 'StoreLabelForm',
    components: {XSelect, XButtonIcon, XInput, XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        record: {
            default: null
        }
    },
    data() {
        return {
            title: null,
            loading: false,
            resource: 'store/labels',
            errors: {},
            form: {},
            locations: [],
            virtual_shops: [],
            shipping_agencies: [],
            shipping_types: [],
        }
    },
    created() {
        this.initTables();
        this.initForm();
    },
    methods: {
        async initTables() {
            await this.$http.get(`/${this.resource}/init_tables`)
                .then(response => {
                    this.locations = response.data.locations
                    this.virtual_shops = response.data.virtual_shops
                    this.shipping_agencies = response.data.shipping_agencies
                    this.shipping_types = response.data.shipping_types
                }).catch(error => {
                    console.log(error)
                })
        },
        initForm() {
            this.title = '';
            this.errors = {};
            this.form = {
                id: null,
                virtual_shop_id: null,
                address: null,
                address_reference: null,
                location_id: null,
                google_maps: null,
                cellphone_number: null,
                shipping_agency_id: null,
                shipping_type_id: '01',
                destination_agency: null,
                number_of_packages: 1,
                payment_method_type: null
            }
        },
        async handleOpen() {
            this.initForm();
            this.title = 'Rótulo'
            this.form = Object.assign({}, this.form, this.record);
            if(!this.form.virtual_shop_id) {
                this.form.virtual_shop_id = (this.virtual_shops.length > 0)?this.virtual_shops[0].id:null
            }
            if(!this.form.shipping_agency_id) {
                this.form.shipping_agency_id = (this.shipping_agencies.length > 0)?this.shipping_agencies[0].id:null
            }
        },
        async onSubmit() {
            if(this.form.shipping_type_id !== '03' ) {
                this.form.payment_method_type = null
            } else {
                if(this.form.payment_method_type === '' || this.form.payment_method_type === null) {
                    this.$message.error('El método de pago es requerido')
                    return false
                }
            }
            if(this.form.shipping_type_id === '02' ) {
                this.form.location_id = null
                this.form.address = null
                this.form.address_reference = null
                this.form.google_maps = null

                if(this.form.destination_agency === '' || this.form.destination_agency === null) {
                    this.$message.error('La agencia de destino es requerido')
                    return false
                }
            } else  {
                if(this.form.location_id === '' || this.form.location_id === null) {
                    this.$message.error('El ubigeo es requerido')
                    return false
                }
                if(this.form.address === '' || this.form.address === null) {
                    this.$message.error('La dirección es requerida')
                    return false
                }
            }

            this.$emit('success', this.form)
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        }
    }
}
</script>
